// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetAssociatedDocumentsQueryVariables = Types.Exact<{
  documentID: Types.Scalars['ID']['input'];
}>;


export type GetAssociatedDocumentsQuery = { __typename?: 'Query', getAssociatedDocuments?: Array<{ __typename?: 'Document', id: string, name: string, type: Types.DocumentType, household: { __typename?: 'Household', id: string }, previousVersion?: { __typename?: 'Document', id: string, name: string, type: Types.DocumentType } | null, nextVersion?: { __typename?: 'Document', id: string, name: string, type: Types.DocumentType } | null } | null> | null };

export const Operations = {
  Query: {
    GetAssociatedDocuments: 'GetAssociatedDocuments' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}


export const GetAssociatedDocumentsDocument = gql`
    query GetAssociatedDocuments($documentID: ID!) {
  getAssociatedDocuments(documentID: $documentID) {
    id
    name
    type
    household {
      id
    }
    previousVersion {
      id
      name
      type
    }
    nextVersion {
      id
      name
      type
    }
  }
}
    `;

/**
 * __useGetAssociatedDocumentsQuery__
 *
 * To run a query within a React component, call `useGetAssociatedDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssociatedDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssociatedDocumentsQuery({
 *   variables: {
 *      documentID: // value for 'documentID'
 *   },
 * });
 */
export function useGetAssociatedDocumentsQuery(baseOptions: Apollo.QueryHookOptions<GetAssociatedDocumentsQuery, GetAssociatedDocumentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssociatedDocumentsQuery, GetAssociatedDocumentsQueryVariables>(GetAssociatedDocumentsDocument, withFetchPolicyContext(options));
      }
export function useGetAssociatedDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAssociatedDocumentsQuery, GetAssociatedDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssociatedDocumentsQuery, GetAssociatedDocumentsQueryVariables>(GetAssociatedDocumentsDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useGetAssociatedDocumentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAssociatedDocumentsQuery, GetAssociatedDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAssociatedDocumentsQuery, GetAssociatedDocumentsQueryVariables>(GetAssociatedDocumentsDocument, withFetchPolicyContext(options));
        }
export type GetAssociatedDocumentsQueryHookResult = ReturnType<typeof useGetAssociatedDocumentsQuery>;
export type GetAssociatedDocumentsLazyQueryHookResult = ReturnType<typeof useGetAssociatedDocumentsLazyQuery>;
export type GetAssociatedDocumentsSuspenseQueryHookResult = ReturnType<typeof useGetAssociatedDocumentsSuspenseQuery>;
export type GetAssociatedDocumentsQueryResult = Apollo.QueryResult<GetAssociatedDocumentsQuery, GetAssociatedDocumentsQueryVariables>;